import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
  faXmark,
  faCheck,
  faDownLong,
  faRightLong,
  faArrowRight,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";

const ProblemSolutionSteps = ({}) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="pet-owner-problem-solution-parent-container">
      <h2 className="containers-headline-text">
        {t("pet owner problem solution headline")}
      </h2>

      <div className="pet-owner-problem-solution-inside-container">
        {/* Card 1 */}
        <div className="pet-owner-problem-card">
          <span className="card-number">1</span>

          <p>{t("pet owner problem solution title 1")}</p>

          <img
            src="/img/PetOwnerProblem.webp"
            alt="Pet Owner Problem"
            loading="lazy"
          />

          <div className="pet-owner-problem-description">
            <p>
              <span className="card-number-inside">1</span>{" "}
              {t("pet owner problem solution title 1")}
            </p>
            <p>
              <FontAwesomeIcon className="problem" icon={faXmark} /> &ensp;
              {t("pet owner problem solution description 1 (part 1)")}
              <br />
              <FontAwesomeIcon className="problem" icon={faXmark} /> &ensp;
              {t("pet owner problem solution description 1 (part 2)")}
            </p>
          </div>
        </div>

        {!isMobile ? (
          <FontAwesomeIcon icon={faArrowRight} />
        ) : (
          <FontAwesomeIcon icon={faArrowDown} />
        )}

        {/* Card 2 */}
        <div className="pet-owner-problem-card">
          <span className="card-number">2</span>

          <p>{t("pet owner problem solution title 2")}</p>

          <img
            src="/img/PetOwnerProblemSolution.webp"
            alt="Pet Owner Problem Solution"
            loading="lazy"
          />

          <div className="pet-owner-problem-description">
            <p>
              <span className="card-number-inside">2</span>{" "}
              {t("pet owner problem solution title 2")}
            </p>
            <p>
              <FontAwesomeIcon className="solution" icon={faCheck} /> &ensp;
              {t("pet owner problem solution description 2 (part 1)")}
              <br />
              <FontAwesomeIcon className="solution" icon={faCheck} /> &ensp;
              {t("pet owner problem solution description 2 (part 2)")}
            </p>
          </div>
        </div>

        {!isMobile ? (
          <FontAwesomeIcon icon={faArrowRight} />
        ) : (
          <FontAwesomeIcon icon={faArrowDown} />
        )}

        {/* Card 3 */}
        <div className="pet-owner-problem-card">
          <span className="card-number">3</span>

          <p>{t("pet owner problem solution title 3")}</p>

          <img
            src="/img/PetGetBackToOwner.webp"
            alt="PetGetBackToOwner"
            loading="lazy"
          />

          <div className="pet-owner-problem-description">
            <p>
              <span className="card-number-inside">3</span>{" "}
              {t("pet owner problem solution title 3")}
            </p>
            <p>{t("pet owner problem solution description 3")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemSolutionSteps;
